import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/regenerator/index.js";
import React, { useEffect, useState } from 'react';
import { useAuthorizedUser } from '@vtblife/block-kit-utils';
import { quizService } from '../../utils/quiz.service';
import { QuizContent } from '../quiz-content/quiz-content';
import { QuizModalLayout } from './components/quiz-modal-layout/quiz-modal-layout';
import { sendQuizAnalytics } from '../../utils/quiz-analytics';
import { getLastSavedStepIndex } from './get-last-saved-step-index';
export var QuizModal = function QuizModal(props) {
  var user = useAuthorizedUser();
  var _onNextStep = props.onNextStep,
    settings = props.settings;
  var id = settings.id;
  useEffect(function () {
    if (props.isOpen && id && (user === null || user === void 0 ? void 0 : user.userId) !== undefined) {
      var touchQuiz = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                try {
                  quizService.touchQuiz({
                    id: id,
                    userId: user === null || user === void 0 ? void 0 : user.userId
                  });
                } catch (error) {
                  console.error('Ошибка сохранения факта просмотра квиза', error);
                }
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function touchQuiz() {
          return _ref.apply(this, arguments);
        };
      }();
      touchQuiz();
    }
  }, [props.isOpen, id, user === null || user === void 0 ? void 0 : user.userId]);
  var onNextStep = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
      var lastStep, step, stepIndex, fields;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!id) {
              _context2.next = 6;
              break;
            }
            lastStep = data.lastStep, step = data.step, stepIndex = data.stepIndex, fields = data.fields;
            _context2.next = 4;
            return quizService.createOrUpdateQuizStep({
              id: id,
              fields: fields,
              ended: lastStep,
              step: stepIndex,
              stepName: step.description || 'empty',
              userId: user === null || user === void 0 ? void 0 : user.userId
            });
          case 4:
            _context2.next = 6;
            return _onNextStep === null || _onNextStep === void 0 ? void 0 : _onNextStep(data);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function onNextStep(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return React.createElement(QuizModalInner, _objectSpread(_objectSpread({}, props), {}, {
    user: user,
    onNextStep: onNextStep
  }));
};
export var QuizModalInner = function QuizModalInner(_ref3) {
  var isOpen = _ref3.isOpen,
    onClose = _ref3.onClose,
    settings = _ref3.settings,
    onLastStepSubmit = _ref3.onLastStepSubmit,
    onNextStep = _ref3.onNextStep,
    user = _ref3.user;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentStep = _useState2[0],
    setCurrentStep = _useState2[1];
  var id = settings.id;
  var handleClose = function handleClose(_ref4) {
    var quizStep = _ref4.quizStep,
      _ref4$quizAction = _ref4.quizAction,
      quizAction = _ref4$quizAction === void 0 ? 'close' : _ref4$quizAction,
      quizChoice = _ref4.quizChoice,
      isResultStep = _ref4.isResultStep;
    if (typeof quizStep !== 'undefined') {
      sendQuizAnalytics({
        quizName: settings.name,
        quizId: id,
        quizStep: quizStep,
        quizAction: quizAction,
        quizChoice: quizChoice
      });
    }
    if (id) {
      var lastSavedStepIndex = getLastSavedStepIndex({
        isResultStep: isResultStep,
        quizStep: quizStep,
        settings: settings
      });
      quizService.closeQuizStep({
        id: id,
        userId: user === null || user === void 0 ? void 0 : user.userId,
        step: lastSavedStepIndex
      }).catch(function (error) {
        return console.error('Ошибка сохранения факта закрытия квиза', error);
      });
    }
    onClose();
  };
  var onComplete = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
      var quizStep, quizAction, quizChoice;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            quizStep = _ref5.quizStep, quizAction = _ref5.quizAction, quizChoice = _ref5.quizChoice;
            handleClose({
              quizStep: quizStep,
              quizAction: quizAction,
              quizChoice: quizChoice,
              isResultStep: true
            });
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function onComplete(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();
  var background = settings.background,
    layout = settings.layout,
    disableClosing = settings.disableClosing;
  return React.createElement(QuizModalLayout, {
    background: background,
    layout: layout,
    onClose: handleClose,
    open: isOpen,
    currentStep: currentStep,
    disableClosing: disableClosing
  }, React.createElement(QuizContent, _objectSpread({
    onLastStepSubmit: onLastStepSubmit,
    onComplete: onComplete,
    onNextStep: onNextStep,
    setCurrentStep: setCurrentStep
  }, settings)));
};